<h1 class="text-center mt-8 pt-8">Esiste già una pratica Inviata o Approvata</h1>
<h1 class="text-center">Non è possibile effettuarne altre</h1>
